export const SHOW = 'loadingLine/SHOW'
export const HIDE = 'loadingLine/HIDE'

const initState = {
    show: false
}

export default (state = initState, action) => {
    switch(action.type) {
        case SHOW:
            return {
                show: true
            }
        case HIDE:
            return {
                ...state,
                show: false
            }
        default:
            return state
    }
}